import { Observable } from 'rxjs';
import { ADSClickRequest, ADSViewRequest, BaseResponse } from '@api/backend';

export abstract class AdsRepository {
  abstract postView(ads_id: string, body: ADSViewRequest): Observable<BaseResponse>;
  abstract postClick(ads_id: string, body: ADSClickRequest): Observable<BaseResponse>;
}